import React from 'react'
import { observer } from 'mobx-react'
import { Form, Input, Divider } from 'antd'
import GoogleButton from './GoogleButton'
import MicrosoftButton from './MicrosoftButton'
import store from 'stores/AuthenticationStore'
import SSAlert from 'ui/shell/SSAlert'
import { SubmitButton, FormIcon } from '../Common/'
import styled, { css } from 'styled-components'


const FormItem = Form.Item

const learnMore = 'https://www.schoolstatus.com/blog/a-unified-future-transforming-student-outcomes'

@observer
class LoginForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: localStorage.loginCheckbox ? localStorage.loginUsername : "",
      isChecked: !!localStorage.loginCheckbox
    }

    if (this.state.isChecked) {
      props.form.getFieldDecorator('userName', { initialValue: this.state.username })
    }
  }

  componentDidMount() {
    store.checkForFailedGoogleAuth(window.location.search)
  }

  handleSubmit = (e) => {
    e.preventDefault()

    const { username, isChecked } = this.state

    this.props.form.validateFields((err, values) => {
      if (!err) {
        store.login(values, e, (isSuccess) => {
          if (!isSuccess) return

          localStorage.loginUsername = username;
          localStorage.loginCheckbox = isChecked ? "1" : "";

          window.location.replace('/r')
        })
      }
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form

    return (
      <div style={{ maxWidth: '475px' }}>
        <div>
          <h2>Welcome to SchoolStatus Classic!</h2>
          <p style={{ width: '85%' }}>Sign in to SchoolStatus Classic using the same method for SchoolStatus. <a href={learnMore} style={{ textDecoration: 'underline' }}>Learn more.</a></p>
        </div>
        <Form onSubmit={this.handleSubmit}>
          {store.showError && (
            <SSAlert
              message={store.errorTitle}
              description={store.errorMessage}
              type="error"
              className="mb-4"
              closable
            />
          )}
          <FormItem>
            {getFieldDecorator('userName', {
              rules: [
                {
                  required: true,
                  message: 'Please enter your email address'
                }
              ]
            })(
              <Input
                data-test="username"
                placeholder="name@example.com"
                name="username"
                size="large"
                className="login-input-dark"
                onChange={(e) => this.setState({ username: e.target.value })}
              />
            )}
          </FormItem>
          <FormItem>
            {getFieldDecorator('password', {
              rules: [
                {
                  required: true,
                  message: 'Please enter your password'
                }
              ]
            })(
              <Input
                data-test="password"
                type="password"
                name="password"
                placeholder="Password"
                className="login-input-dark"
                size="large"
              />
            )}
          </FormItem>
          <FormOptionsContainer>
            <FormItem className="mb-1">
              <FormCheckbox>
                <input
                  type="checkbox"
                  checked={this.state.isChecked}
                  onChange={(e) => this.setState({ isChecked: !this.state.isChecked })}
                /> Remember me
              </FormCheckbox>
            </FormItem>
            <FormItem className="mb-1">
              <div className="text-center">
                <a href="/reset">Forgot password?</a>
              </div>
            </FormItem>
          </FormOptionsContainer>

          <FormItem>
            <SubmitButton
              data-test="submit"
              size="lg"
              color="dark"
              style={{ backgroundColor: "#000", color: "#fff", fontSize: '16px' }}
              className="w-100 classic-login-button"
              loading={store.isLoggingIn}
              id="classic-login-button"
            >
              Sign in to SchoolStatus Classic
            </SubmitButton>
            <Divider className="my-3">
              <span style={{ color: 'rgba(0, 0, 0, 0.4)' }}>or continue with</span>
            </Divider>
            <GoogleButton
              label="Google"
              type="light"
              onClick={googleLogin}
              title="Login using your Google Apps for Education account"
              id="google-login-button"
              className="google-login-button"
            />
            <MicrosoftButton
              onClick={MSLogin}
              id="microsoft-login-button"
              className="microsoft-login-button"
            />
          </FormItem>
        </Form>
      </div>

    )
  }
}

function googleLogin() {
  window.location.replace('/auth/google_oauth2')
}

function MSLogin() {
  window.location.replace('/auth/microsoft_office365')
}

const WrappedLoginForm = Form.create()(LoginForm)

const FormOptionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 1rem;
`;

const FormCheckbox = styled.div`
  & > input[type=checkbox] {
    accent-color: #000;
  }
`;


export default WrappedLoginForm
